import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Attorneys from '../../api/attorneys';

import ErrorAttorney from '../../components/attorneys/ErrorAttorney';
import AttorneyGA from '../../components/attorneys/AttorneyGA';
import AttorneyVA from '../../components/attorneys/AttorneyVA';
import AttorneyMAO from '../../components/attorneys/AttorneyMAO';
import AttorneyHR from '../../components/attorneys/AttorneyHR';
import AttorneySAH from '../../components/attorneys/AttorneySAH';

const componentMap = {
	AttorneyGA: AttorneyGA, // Mapping 'AttorneyGA' to AttorneyGA component
	AttorneyVA: AttorneyVA, // Mapping 'AttorneyVA' to AttorneyVA component
	AttorneyMAO: AttorneyMAO, // Mapping 'AttorneyMAO' to AttorneyMAO component
	AttorneyHR: AttorneyHR, // Mapping 'AttorneyHR' to AttorneyHR component
	AttorneySAH: AttorneySAH, // Mapping 'AttorneyHR' to AttorneyHR component
	// Add more components here as needed
};

const calculateYearsPassed = startDate => {
	const start = new Date(startDate);
	const today = new Date();
	let years = today.getFullYear() - start.getFullYear();

	if (
		today.getMonth() < start.getMonth() ||
		(today.getMonth() === start.getMonth() && today.getDate() < start.getDate())
	) {
		years--;
	}
	return years;
};

const AttorneySinglePage = props => {
	const { slug } = useParams();

	const AttorneyDetails = Attorneys.find(item => item.slug === slug);

	const SubmitHandler = e => {
		e.preventDefault();
	};

	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<Fragment>
			<Navbar />
			<PageTitle pageTitle={AttorneyDetails.name} pagesub='Equipe' />
			<section className='pt-[100px] pb-[80px] md:pt-[90px] md:pb-[60px] sm:pt-[80px] sm:pb-[50px]'>
				<div className='wraper'>
					<div className='grid grid-cols-12 gap-3'>
						<div className='col-span-1'></div>
						<div className='col-span-10 md:col-span-12'>
							<div className='grid grid-cols-12 gap-4 items-stretch'>
								<div className='col-span-6 md:col-span-6 sm:col-span-12'>
									<div className='bg-[#f5f5f5] text-center pt-[47px] md:pt-[56px]'>
										<div className='w-[380px] h-[380px] md:w-[350px] md:h-[350px] col:w-[300px] col:h-[300px] mx-auto mb-[47px] md:mb-[56px]'>
											<img
												className='rounded-full border-[15px] border-[#c0b596]'
												src={AttorneyDetails.AtImg}
												alt=''
											/>
										</div>
										<div className='bg-[#dddad3] py-[25px]'>
											<h2 className='text-[30px] font-normal text-[#282e3f] col:text-[20px]'>
												{AttorneyDetails.name}
											</h2>
										</div>
									</div>
								</div>
								<div className='col-span-6 md:col-span-6 sm:col-span-12'>
									<div className='bg-[#f5f5f5] sm:mt-[30px] h-full'>
										<div className='bg-[#ddd] py-[25px]'>
											<h3 className='text-center text-[30px] text-[#666] col:text-[20px]'>
												Informations Importantes
											</h3>
										</div>
										<div className='px-[30px] pb-[30px] pt-[20px]'>
											<ul>
												<li className='text-[16px] text-[#666] mb-[15px] md:mt-[12px]'>
													<span className='text-[#666] text-[20px] font-bold font-heading-font'>
														Matières :<br />
													</span>
													<ul>
														{AttorneyDetails.practice.map((item, index) => (
															<li
																key={index}
																className="relative pl-[15px] pb-[1px] text-[15px] text-[#333] before:absolute before:left-0 before:top-0 before:content-['\f0da'] before:font-['FontAwesome'] before:text-[#c0b596] before:text-[16px]"
															>
																{item}
															</li>
														))}
													</ul>
												</li>
												<li className='text-[16px] text-[#666] mb-[15px] md:mt-[12px]'>
													<span className='text-[#666] text-[20px] font-bold font-heading-font'>
														Expérience :&nbsp;
													</span>
													{calculateYearsPassed(AttorneyDetails.startYear)} ans
												</li>
												<li className='text-[16px] text-[#666] mb-[15px] md:mt-[12px]'>
													<span className='text-[#666] text-[20px] font-bold font-heading-font'>
														Langues :&nbsp;
													</span>
													<ul>
														{AttorneyDetails.lang.map((item, index) => (
															<li
																key={index}
																className="relative pl-[15px] pb-[1px] text-[15px] text-[#333] before:absolute before:left-0 before:top-0 before:content-['\f0da'] before:font-['FontAwesome'] before:text-[#c0b596] before:text-[16px]"
															>
																{item}
															</li>
														))}
													</ul>
												</li>
												<li className='text-[16px] text-[#666] mb-[15px] md:mt-[12px]'>
													<span className='text-[#666] text-[20px] font-bold font-heading-font'>
														Téléphone :&nbsp;
													</span>
													{AttorneyDetails.phone}
												</li>
												<li className='text-[16px] text-[#666] mb-[0px] md:mt-[12px]'>
													<span className='text-[#666] text-[20px] font-bold font-heading-font'>
														E-mail :&nbsp;
													</span>
													{AttorneyDetails.email}
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
							{AttorneyDetails && componentMap[AttorneyDetails.comp]
								? React.createElement(componentMap[AttorneyDetails.comp])
								: React.createElement(ErrorAttorney)}
						</div>
						<div className='col-span-1'></div>
					</div>
				</div>
			</section>
			<Footer />
			<Scrollbar />
		</Fragment>
	);
};
export default AttorneySinglePage;
